export function HandleRemove(mapItem, items, setItems, toDeleteList,
                             deleteItems, setDeleteItems,
                             mapId, itemId, itemName, availableitems,
                             itemsToSelect, setItemsToSelect,
                             setSelectedValue, setOrder, setSelectedItem){

    //console.log(mapItem)

    const newList = items.filter((item) => item !== mapItem);
    setItems(newList);

    toDeleteList = deleteItems

    toDeleteList.push({
        mapId: mapId,
        itemId: itemId
    })
    setDeleteItems(toDeleteList)

    let item = {
        value: itemId,
        label: itemName
    }
    availableitems = itemsToSelect
    availableitems.push(item)
    setItemsToSelect(availableitems)

    setSelectedValue(null)
    setOrder(null)
    setSelectedItem(null)

}